var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicableActionsStranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9354 7.22328L20.5747 8.94964C21.1096 9.08872 21.6594 8.78069 21.8027 8.26163C21.946 7.74258 21.6286 7.20905 21.0937 7.06997L16.7629 5.94384L13.9354 7.22328Z",
    fill: "#204BE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72265 3.59319L1.72396 2.0334C1.18907 1.89431 0.639282 2.20235 0.495961 2.7214C0.35264 3.24046 0.670063 3.77399 1.20494 3.91307L4.89524 4.87263L7.72265 3.59319Z",
    fill: "#204BE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0954503 10.4344C-0.138575 9.94742 0.0725314 9.37124 0.566969 9.1475L20.5856 0.0888394C21.08 -0.1349 21.6705 0.0785326 21.9046 0.565554C22.1386 1.05257 21.9275 1.62876 21.433 1.8525L1.41445 10.9112C0.920011 11.1349 0.329475 10.9215 0.0954503 10.4344Z",
    fill: "#D1C022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicableActionsStranding);
export default __webpack_public_path__ + "static/media/applicable-actions-stranding.b4d06ee3190f8e0117e071edff6ec14b.svg";
export { ForwardRef as ReactComponent };